export default ({ url, method, body }) => {
  let options = {
    method: 'GET',
    headers: {},
  };
  if (body)
    options = {
      body: JSON.stringify(body),
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
  if (method) options.method = method;

  options.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;

  return new Promise((resolve, reject) => {
    fetch(`${process.env.REACT_APP_API_URL}/${url}`, options)
      .then(response => {
        if (response.status === 401 && url !== 'auth/login') {
          localStorage.clear();
          return (window.location = '/');
        }
        if (
          response.headers.get('Authorization') &&
          localStorage.getItem('type')
        )
          localStorage.setItem(
            'token',
            response.headers.get('Authorization').replace('Bearer ', '')
          );
        return response.json();
      })
      .then(json => {
        if (!json) return;
        if (json.error) {
          if (json.error === 'Google Cloud is down')
            alert(
              'Google Cloud storage is currently down, please try again later.'
            );
          return reject(json.error);
        }
        if (json.errors)
          return reject(json.errors[Object.keys(json.errors)[0]][0]);
        resolve(json);
      })
      .catch(error => {
        reject(error);
      });
  });
};



// WEBPACK FOOTER //
// ./src/request.js